import { useCallback, useEffect, useState, useRef, useLayoutEffect } from "react"

const IS_SERVER = typeof window === "undefined"

export const useSessionStorage = (key, initialValue) => {
  const [invalidated, setInvalidated] = useState(false);

  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const item = window.sessionStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      return initialValue;
    }
  });

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to sessionStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to storage
      if(!invalidated) {
        window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
    }
  };

  const invalidate = () => {
    setInvalidated(true);
    window.sessionStorage.removeItem(key);
  };

  return [storedValue, setValue, invalidate];
};

// //import { useIsomorphicLayoutEffect } from "usehooks-ts"

// export const useIsomorphicLayoutEffect =
//   typeof window !== 'undefined' ? useLayoutEffect : useEffect

// export function useEventCallback(fn) {
//   const ref = useRef(() => {
//     throw new Error("Cannot call an event handler while rendering.")
//   })

//   useIsomorphicLayoutEffect(() => {
//     ref.current = fn
//   }, [fn])

//   return useCallback((...args) => ref.current?.(...args), [ref])
// }

// export function useEventListener(eventName, handler, element, options) {
//   // Create a ref that stores handler
//   const savedHandler = useRef(handler)

//   useIsomorphicLayoutEffect(() => {
//     savedHandler.current = handler
//   }, [handler])

//   useEffect(() => {
//     // Define the listening target
//     const targetElement = element?.current ?? window

//     if (!(targetElement && targetElement.addEventListener)) return

//     // Create event listener that calls handler function stored in ref
//     const listener = event => {
//       savedHandler.current(event)
//     }

//     targetElement.addEventListener(eventName, listener, options)

//     // Remove event listener on cleanup
//     return () => {
//       targetElement.removeEventListener(eventName, listener, options)
//     }
//   }, [eventName, element, options])
// }

// export function useSessionStorage(key, initialValue, options = {}) {
//   const { initializeWithValue = true } = options

//   const serializer = useCallback(
//     value => {
//       if (options.serializer) {
//         return options.serializer(value)
//       }

//       return JSON.stringify(value)
//     },
//     [options]
//   )

//   const deserializer = useCallback(
//     value => {
//       if (options.deserializer) {
//         return options.deserializer(value)
//       }
//       // Support 'undefined' as a value
//       if (value === "undefined") {
//         return undefined
//       }

//       const defaultValue =
//         initialValue instanceof Function ? initialValue() : initialValue

//       let parsed
//       try {
//         parsed = JSON.parse(value)
//       } catch (error) {
//         console.error("Error parsing JSON:", error)
//         return defaultValue // Return initialValue if parsing fails
//       }

//       return parsed
//     },
//     [options, initialValue]
//   )

//   // Get from session storage then
//   // parse stored json or return initialValue
//   const readValue = useCallback(() => {
//     const initialValueToUse =
//       initialValue instanceof Function ? initialValue() : initialValue

//     // Prevent build error "window is undefined" but keep working
//     if (IS_SERVER) {
//       return initialValueToUse
//     }

//     try {
//       const raw = window.sessionStorage.getItem(key)
//       return raw ? deserializer(raw) : initialValueToUse
//     } catch (error) {
//       console.warn(`Error reading sessionStorage key “${key}”:`, error)
//       return initialValueToUse
//     }
//   }, [initialValue, key, deserializer])

//   const [storedValue, setStoredValue] = useState(() => {
//     if (initializeWithValue) {
//       return readValue()
//     }

//     return initialValue instanceof Function ? initialValue() : initialValue
//   })

//   // Return a wrapped version of useState's setter function that ...
//   // ... persists the new value to sessionStorage.
//   const setValue = useEventCallback(value => {
//     // Prevent build error "window is undefined" but keeps working
//     if (IS_SERVER) {
//       console.warn(
//         `Tried setting sessionStorage key “${key}” even though environment is not a client`
//       )
//     }

//     try {
//       // Allow value to be a function so we have the same API as useState
//       const newValue = value instanceof Function ? value(readValue()) : value

//       // Save to session storage
//       window.sessionStorage.setItem(key, serializer(newValue))

//       // Save state
//       setStoredValue(newValue)

//       // We dispatch a custom event so every similar useSessionStorage hook is notified
//       window.dispatchEvent(new StorageEvent("session-storage", { key }))
//     } catch (error) {
//       console.warn(`Error setting sessionStorage key “${key}”:`, error)
//     }
//   })

//   const removeValue = useEventCallback(() => {
//     // Prevent build error "window is undefined" but keeps working
//     if (IS_SERVER) {
//       console.warn(
//         `Tried removing sessionStorage key “${key}” even though environment is not a client`
//       )
//     }

//     const defaultValue =
//       initialValue instanceof Function ? initialValue() : initialValue

//     // Remove the key from session storage
//     window.sessionStorage.removeItem(key)

//     // Save state with default value
//     setStoredValue(defaultValue)

//     // We dispatch a custom event so every similar useSessionStorage hook is notified
//     window.dispatchEvent(new StorageEvent("session-storage", { key }))
//   })

//   useEffect(() => {
//     setStoredValue(readValue())
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [key])

//   const handleStorageChange = useCallback(
//     event => {
//       if (event.key && event.key !== key) {
//         return
//       }
//       setStoredValue(readValue())
//     },
//     [key, readValue]
//   )

//   // this only works for other documents, not the current one
//   useEventListener("storage", handleStorageChange)

//   // this is a custom event, triggered in writeValueToSessionStorage
//   // See: useSessionStorage()
//   useEventListener("session-storage", handleStorageChange)

//   return [storedValue, setValue, removeValue]
// }

